import { Helpers } from '../../helpers';
import { IPondSize } from '../../interfaces/ipond-size';
import { ProjectPondParameter } from '../project-pond-parameter';

export class PondSizeBase {
  PondSizeId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectPondParameters_PondSize?: Array<ProjectPondParameter> | null;

  constructor(item?: IPondSize) {
    if (item) {

      this.PondSizeId = item.PondSizeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectPondParameters_PondSize = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_PondSize);
    }
  }
}